import React from 'react';
import AuthCard from '../components/AuthCard';

const Register = () => <AuthCard mode="signup" />;

export default Register;
